import React, {
    useMemo,
} from 'react';

import * as UTILS from "../utils";
import * as CONSTANTS from "../constants";

import ViewAlternativeDates from "./view-alternative-dates";

export default function InstanceEventSummary(props) {

    const formattedDate = useMemo(() => {
        return UTILS.formatDateTime(CONSTANTS.INSTANCE?.date);
    }, [CONSTANTS.INSTANCE?.date]);

    return (
        <header className="instance-event-summary instance-event-summary__header">
            {CONSTANTS.EVENT.name ?
                <h1 className="instance-event-summary__title">{ CONSTANTS.EVENT.name }</h1>
            :null}

            <div className="instance-event-summary__header-flex">
                {CONSTANTS.EVENT?.attributes[CONSTANTS.VENUE_ATTRIBUTE_NAME] ?
                    <p className="instance-event-summary__venue">
                        <span className={ CONSTANTS.EVENT.attributes[CONSTANTS.VENUE_ATTRIBUTE_NAME] }></span>
                        { CONSTANTS.EVENT.attributes[CONSTANTS.VENUE_ATTRIBUTE_NAME] }</p>
                :null}
                {formattedDate ?
                    <p className="instance-event-summary__date">{ formattedDate }</p>
                :null}
            </div>

            {props.showAlternativeDates &&
                <ViewAlternativeDates />
            }
        </header>
    );
}